export const CHANNEL_MEDIA_RULES = {
    telegram: {
        image: { maxBytes: 10 * 1024 * 1024, mimes: ['image/jpeg', 'image/png', 'image/webp', 'image/gif'] },
        video: { maxBytes: 50 * 1024 * 1024, mimes: ['video/mp4', 'video/quicktime', 'video/webm'] },
        audio: { maxBytes: 20 * 1024 * 1024, mimes: ['audio/mpeg', 'audio/ogg', 'audio/mp4', 'audio/wav'] },
    },
    'whatsapp-cloud-api': {
        image: { maxBytes: 5 * 1024 * 1024, mimes: ['image/jpeg', 'image/png'] },
        video: { maxBytes: 16 * 1024 * 1024, mimes: ['video/mp4', 'video/3gpp'] },
        audio: {
            maxBytes: 16 * 1024 * 1024,
            mimes: ['audio/aac', 'audio/amr', 'audio/mpeg', 'audio/mp4', 'audio/ogg'],
        },
    },
    // webchat / email / instagram-dm: sem adapter de mídia outbound → ausência = não suporta.
};
/**
 * Verdito puro para um item de mídia num canal. `channel` é string (o caller
 * costuma ter só a string do canal da conversa/evento). Canal desconhecido ou
 * sem regra para o tipo ⇒ `kind-unsupported` (o canal não recebe aquele tipo).
 */
export function evaluateChannelMedia(params) {
    const channelRules = CHANNEL_MEDIA_RULES[params.channel];
    const rule = channelRules?.[params.kind];
    if (rule === undefined)
        return { ok: false, reason: 'kind-unsupported' };
    if (!rule.mimes.includes(params.mimeType))
        return { ok: false, reason: 'mime-unsupported' };
    if (params.sizeBytes > rule.maxBytes)
        return { ok: false, reason: 'too-large' };
    return { ok: true, rule };
}
//# sourceMappingURL=media-rules.js.map